import React from 'react'
import { useChatWindow } from '@ztechapps/chat.chat-window'
import ReadMoreButton from '../../../read-more-button'

export const GetMonthlyPrice = () => {
  const { toggleShow } = useChatWindow()
  return (
    <ReadMoreButton className="animate__animated animate__fadeInUp" onClick={toggleShow}>
      <div className="blink_me" id={'message-us'}>
        Click here to get your guaranteed monthly price
      </div>
    </ReadMoreButton>
  )
}
